// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Netherlands */
const NL = /^(?:(?:6[1-58]|970\d)\d{7})$/;

export default NL;
